// extracted by mini-css-extract-plugin
export default {"blockwrapper":"NO","header":"OO","name":"PO","columns":"QO","imagewrapper":"RO","addinfo":"SO","description":"TO","price":"UO","old":"VO","new":"WO","desc_d":"XO","infoblock":"YO","desc_m":"ZO"};
    if(module.hot) {
      // 1711394579162
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  